import { createSelector } from 'reselect';
import { initialState } from '../reducers/dashboard.reducer';
import { DASHBOARD } from '../constants/dashboard.constants';

const selectState = state => state?.[DASHBOARD] || initialState;

const selectDashboardsData = createSelector(
  selectState,
  state => state.get('data')
);

const selectDashboardsSeq = createSelector(
  selectDashboardsData,
  data => data.valueSeq()
);

export const selectDashboards = createSelector(
  selectDashboardsSeq,
  seq => seq.toList()
);

export const selectDashboardsFetched = createSelector(
  selectState,
  state => state.get('fetched')
);

export const selectSelectedDashboard = createSelector(
  selectState,
  state => state.get('selected')
);

export const selectEditDashboard = createSelector(
  selectState,
  state => state.get('editDashboard')
);

export const selectLoading = createSelector(
  selectState,
  state => state.get('loading')
);